import { FC } from 'react';
import { IconButton } from '@mui/material';
import {
  Crop54 as DayIcon,
  CalendarViewWeek as WeekIcon,
  CalendarViewMonth as MonthIcon,
} from '@mui/icons-material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import './CalendarViewSwitcher.scss';
import { CalendarViewType } from '../../../data-access';

interface CalendarViewSwitcherProps {
  className?: string;
  onViewChange: (view: CalendarViewType) => void;
  view: CalendarViewType;
}

const viewConfig: Record<CalendarViewType, { icon: typeof DayIcon; label: string }> = {
  day: { icon: DayIcon, label: 'calendar.views.day' },
  week: { icon: WeekIcon, label: 'calendar.views.week' },
  month: { icon: MonthIcon, label: 'calendar.views.month' },
};

const CalendarViewSwitcher: FC<CalendarViewSwitcherProps> = ({ className, onViewChange, view }) => {
  const { t } = useTranslation();
  const isActive = (viewType: CalendarViewType) => view === viewType;

  return (
    <div className={clsx('calendar-view-switcher', className)}>
      {(
        Object.entries(viewConfig) as [CalendarViewType, (typeof viewConfig)[CalendarViewType]][]
      ).map(([viewType, config]) => {
        const ViewIcon = config.icon;
        const label = t(config.label);
        return (
          <IconButton
            key={viewType}
            onClick={() => onViewChange(viewType)}
            className={clsx('calendar-view-switcher__button', {
              'calendar-view-switcher__button--active': isActive(viewType),
            })}
            aria-label={label}
            title={label}
          >
            <ViewIcon className="calendar-view-switcher__button__icon" />
          </IconButton>
        );
      })}
    </div>
  );
};

export default CalendarViewSwitcher;
